import React, { Component } from 'react';

import i18n from 'i18n-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';

export default class Calender extends Component {
  constructor(props) {
    super(props);
  }

  static contextTypes = {
    router: () => true,
  }
  
  render() {
    const { to } = this.props;
    const { history } = this.context.router;
    if (to) {
      return (
        <Link
          className="backLink"
          to={to}
        >
          <FontAwesomeIcon icon={['fas', 'caret-left']} />
          <p>{i18n.translate('general.back')}</p>
        </Link>
      );
    }
    return (
      <button
        className="backButton"
        onClick={history.goBack}
        >
          <FontAwesomeIcon icon={['fas', 'caret-left']} />
          <p>{i18n.translate('general.back')}</p>
      </button>
    )
  }
};